export const env = {
    logRocketAppId: process.env.NEXT_PUBLIC_LOGROCKET_APP_ID,
    isNetlifyFunction: process.env.IS_NETLIFY_FUNCTION
};
